import { AskFieldType } from '../../../api/configurations/emailSettings/types';

export type EmailFieldOptions = {
  required: boolean;
  confirmation_type: string;
};

export type FormValues = {
  email_collect: boolean;
  phone_number_collect: boolean;
  field_order?: string;
  email: EmailFieldOptions;
  phone_number: {
    required: boolean;
  };
};

export type PreparedData = {
  [key: string]: AskFieldType;
};

export enum OrderFields {
  phone_number = 'phone_number',
  email = 'email'
}
